import { ConfigFilesVersion } from "types/config-files/mainConfig";
import { NULL } from "constants/primitives";
import { STATIC_URL } from "core/config";
import trim from "./trim";

const getStaticFileUrl = (
  filename: string,
  version: ConfigFilesVersion = NULL
) => {
  const filePath = trim(filename, "/").replace("//", "/"); // fix double // which may appear in some urls if path isn't concatenated correctly
  return `${STATIC_URL}/${filePath}${version ? `?v=${version}` : ""}`;
};

export default getStaticFileUrl;
